export const topMeels=[
    {
        image:"https://cdn.pixabay.com/photo/2017/12/09/08/18/pizza-3007395_1280.jpg",
        title:"Pizza"
    },
    {
        image:"https://cdn.pixabay.com/photo/2016/03/05/19/02/hamburger-1238246_1280.jpg",
        title:"Burger"
    },
    {
        image:"https://cdn.pixabay.com/photo/2019/04/08/18/35/sandwich-4112566_640.jpg",
        title:"Sandwich"
    }
    ,
    {
        image:"https://cdn.pixabay.com/photo/2015/10/01/14/26/fried-rice-967081_640.jpg",
        title:"Fried Rice"
    }
    ,
    {
        image:"https://cdn.pixabay.com/photo/2016/03/27/22/38/cake-1284548_640.jpg",
        title:"Cake"
    }
    ,
    {
        image:"https://cdn.pixabay.com/photo/2022/06/14/18/57/chicken-biryani-7262650_640.jpg",
        title:"Biryani"
    }
    ,
    {
        image:"https://cdn.pixabay.com/photo/2012/07/09/07/16/thali-51996_1280.jpg",
        title:'Thali'
    }
    ,
    {
        image:"https://images.pexels.com/photos/4331490/pexels-photo-4331490.jpeg?auto=compress&cs=tinysrgb&w=600",
        title:"North Indian Food"
    }
    ,
    {
        image:"https://cdn.pixabay.com/photo/2017/08/25/15/10/egg-roll-2680478_640.jpg",
        title:"Rolls"
    }
    ,
    {
        image:"https://images.pexels.com/photos/2313686/pexels-photo-2313686.jpeg?auto=compress&cs=tinysrgb&w=600",
        title:"Chiken"
    },
    {
        image:"https://images.pexels.com/photos/2764905/pexels-photo-2764905.jpeg?auto=compress&cs=tinysrgb&w=600",
        title:"Noodles"
    },
    {
        image:"https://images.pexels.com/photos/5560763/pexels-photo-5560763.jpeg?auto=compress&cs=tinysrgb&w=600",
        title:"Dosa"
    },

]